import script from "./edit.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit.vue?vue&type=script&lang=ts&setup=true"

import "./edit.vue?vue&type=style&index=0&id=9c8539aa&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c8539aa"]])

export default __exports__